import { FC } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { FormTextField } from '../../../../lib/components';
import { CompanyForm, CompanyFormProps } from '../shared/companyForm';

type Props = Omit<CompanyFormProps, 'children'>;

export const ContactDataForm: FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <CompanyForm {...props}>
      <FormTextField
        label={t('employee:FIRST_NAME')}
        placeholder={t('employee:FIRST_NAME')}
        name="first_name"
        validation={Yup.string().nullable()}
        xs={6}
      />
      <FormTextField
        label={t('employee:LAST_NAME')}
        placeholder={t('employee:LAST_NAME')}
        name="last_name"
        xs={6}
        validation={Yup.string().nullable()}
      />
      <FormTextField
        label={t('auth:email')}
        placeholder={t('auth:email')}
        name="email"
        xs={6}
        validation={Yup.string().email(t('form:INVALID_EMAIL')).nullable()}
      />
      <FormTextField
        label={t('company:TELEPHONE')}
        placeholder={t('company:TELEPHONE')}
        name="phone"
        xs={6}
      />
    </CompanyForm>
  );
};
